export enum GoogleMapStyle {
  Light = 'light',
  Dark = 'dark',
  Satellite = 'satellite',
  Dark3D = 'dark3d',
  Light3D = 'light3d',
  Drawing = 'drawing',
  Transit = 'transit',
  Hybrid = 'hybrid',
  TERRAIN = 'terrain',
}
